/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-props-no-spreading */
import { forwardRef, HTMLProps } from 'react';
import { cn } from '@/utils'; // Replace with your actual utility for classnames

interface InputProps extends Omit<HTMLProps<HTMLInputElement>, 'ref'> {
  className?: string;
  hasIcon?: boolean;
  rightIconName?: string;
  leftIconName?: string;
  varientSize?: 'sm' | 'lg'; // Adjust with other sizes if needed
  iconStyle?: string;
  onClick?: () => void;
  // Add form-specific props that should not be passed to DOM
  haserror?: boolean;
  onTouchHandler?: any;
  enable?: boolean;
  controlfilling?: boolean;
  touched?: boolean;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      className,
      type,
      hasIcon = false,
      rightIconName = '',
      leftIconName = '',
      varientSize = 'lg',
      iconStyle = '',
      onClick,
      haserror,
      onTouchHandler,
      enable,
      controlfilling,
      touched,
      ...props
    },
    ref,
  ) => {
    const sizeVariant = {
      sm: 'h-[2.25rem]',
      lg: 'h-[2.75rem]',
    };

    if (hasIcon) {
      return (
        <div
          className={cn(
            `group flex w-full items-center justify-center gap-[2px] rounded-md border bg-white text-[#BDBDBD] file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-[#BDBDBD] focus-visible:outline-none disabled:cursor-not-allowed disabled:border-b-gray-600 disabled:opacity-5`,
            className,
            sizeVariant[varientSize],
          )}
        >
          {rightIconName && (
            <i
              className={cn(
                `material-symbols-outlined cursor-pointer px-1 text-2xl group-hover:bg-primary-50`,
                iconStyle,
              )}
              onClick={onClick}
            >
              {rightIconName}
            </i>
          )}
          <input
            type={type}
            className={cn(
              'border-input flex h-full w-full bg-transparent pl-[8px] text-base md:text-sm text-[#BDBDBD] ring-0 transition-all duration-200 file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-[#BDBDBD] hover:bg-primary-50 focus:border-none focus:outline-none disabled:cursor-not-allowed disabled:opacity-50',
            )}
            ref={ref}
            {...props}
          />
          {leftIconName && (
            <i
              className={cn(
                `material-symbols-outlined cursor-pointer px-1 text-2xl group-hover:bg-primary-50`,
                iconStyle,
              )}
              onClick={onClick}
            >
              {leftIconName}
            </i>
          )}
        </div>
      );
    }

    return (
      <input
        type={type}
        className={cn(
          'ring-offset-background flex h-10 w-full rounded-md border border-gray-400 bg-[#F8F8FF] px-3 py-2 text-base md:text-sm text-[#475467] transition-all duration-200 file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-[#BDBDBD] hover:bg-primary-50 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50',
          className,
          sizeVariant[varientSize],
        )}
        ref={ref}
        {...props}
      />
    );
  },
);

Input.displayName = 'Input';

export default Input;